import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
const { colors } = constants;

export const sectionCss: CSSObject = {
  padding: "16px 24px",
  borderTop: `1px solid ${colors.ui.neutral[100]}`,
};

export const titleCss: CSSObject = {
  fontWeight: 700,
};
